<template>
  <table class="cus-addable-table" :name="options.Key">
    <tbody>
      <tr class="cus-table-thead">
        <th style="width: 50px">序号</th>
        <th v-for="(column, i) in options.TableColumns" :key="i" :style="`width: ${column.Width || 'initial'}`">
          {{column.Name}}
        </th>
        <th style="width: 80px"><el-button size="small" type="primary" @click="addRow(false)">新增</el-button></th>
      </tr>
      <tr v-for="(obj, i) in rows" :key="i">
        <td>
          <p class="tsw-p">{{obj.ORDER_NUMBER}}</p>
        </td>
        <td v-for="(column, j) in options.TableColumns" :key="j">
          <p class="cat-p">
            <el-form-item v-msg class="tender-form-label" label-width="0" :prop="`${options.Key}[${i}].${column.Key}`" :name="column.Key" :rules="xrules[j]">
              <bear-date-picker
                v-if="isDateTime(column.Type)"
                v-model="obj[column.Key]"
                :type="column.Type"
                :format="column.Format"
                @change="inputChangeHandle"
              ></bear-date-picker>
              <template v-else-if="column.Type === 'text'">{{obj[column.Key]}}</template>
              <bear-input 
                v-else
                v-model="obj[column.Key]" 
                @input="inputChangeHandle"
              ></bear-input>
            </el-form-item>
          </p>
        </td>
        <td>
          <p class="tsw-p">
            <el-button v-if="obj.deletable" size="small" type="danger" @click="delRow(i)">删除</el-button>
          </p>
        </td>
      </tr>
      <tr v-if="options.Total">
        <td>
          <p>{{rows.length + 1}}</p>
        </td>
        <td>
          <p>{{options.Total.Label}}</p>
        </td>
        <td :colspan="options.TableColumns.length" class="text-left">
          <p class="cat-p">
            <el-form-item 
              v-msg
              label-width="0" 
              :prop="options.Total.Key" 
              :rules="[{required: true, message: ' '}]"
            >
              <bear-input 
                v-model="form[options.Total.Key]" 
                @input="inputChangeHandle"
              ></bear-input>
            </el-form-item>            
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mixForFormItem } from '../../../js/mixins'
import utils from '../../../js/utils'
import formUtils from '../../../js/formUtils'
import BearInput from '~@/input/src'
import BearDatePicker from '~@/date-picker/src'
export default {
  name: 'FormAddableTable',
  components: {
    BearInput,
    BearDatePicker
  },
  mixins: [mixForFormItem],
  computed: {
    xrules() {
      let {TableColumns = []} = this.options
      const resRules = []
      TableColumns.forEach((column) => {
        let _rules = formUtils.initFormRules(column, this.form, this.param)
        this.addRefRules(_rules, column)
        resRules.push(_rules)
      })
      return resRules
    },
    requiredColumns() {
      const {length} = this.rows
      const {TableColumns = [], Total} = this.options
      const x = Total ? 1 : 0
      return length * TableColumns.filter(obj => obj.Required !== false).length + x
    },
    value() {
      let {options, form} = this
      return form[options.Key] || []
    }
  },
  data() {
    return {
      rows: []
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        if(options.Value) {
          form[options.Key] = options.Value
          this.rows = options.Value
        } else {
          form[options.Key] = this.rows
          this.addRow(true)
        }
        if(options.Total) {
          form[options.Total.Key] = options.Total.Value || ''
        }
        this.$nextTick(() => {
          this.doValidate()
        })
      }).catch(() => {
        this.rows = form[options.Key] || []
        this.$nextTick(() => {
          this.doValidate()
        })
      })
    },
    addRow(first) {
      let {TableColumns = []} = this.options
      let row = {}
      this.rows = this.rows || []
      TableColumns.forEach(column => {
        if(this.isDateTime(column.Type)) {
          row[column.Key] = null
        } else {
          row[column.Key] = ''
        }
      })
      row.deletable = true
      this.rows.push(row)
      row.ORDER_NUMBER = this.rows.length
      this.$nextTick(() => {
        first || this.doValidate()
      })
    },
    delRow(index) {
      this.rows.splice(index, 1)
      this.rows.forEach((row, i) => {
        row.ORDER_NUMBER = i + 1
      })
      this.$nextTick(() => {
        this.doValidate()
      })
    },
    inputChangeHandle() {
      this.doValidate()
    },
    addRefRules(_rules, column) {
      let {RefType} = column
      switch(RefType) {
        case '权重':
          this.addRefWeight(_rules, column)
          break;
        case '分数':
          this.addRefWeight(_rules, column)
          break;
        default: 
          break;
      }
    },
    addRefWeight(_rules, column) {
      let {Key} = column
      let {rows = []} = this
      _rules.push({
        validator: (rule, value, callback) => {
          const values = []
          rows.forEach((row) => {
            values.push(row[Key])
          })
          if(!/^\d+(\.\d{1,2})?$/.test(value)) {
            callback(new Error('请填写数字'))
          } else if(-value < -1) {
            callback(new Error('权重累加不能大于1'))
          } else {
            if(values.indexOf('') >= 0) {
              callback()
            } else {
              let total = values.reduce((pre, cur, index) => {
                return (0 - -pre - -cur).toFixed(2)
              }, '0')
              if(total === '1.00') {
                callback()
              } else {
                callback(new Error('请填写数字且权重累加为1'))
              }
            }
          }
        }
      })
    },
    addRefScore(_rules, column) {
      let {Key, RefKeys} = column
      let {form} = this
      _rules.push({
        validator: (rule, value, callback) => {
          const values = []
          const [refKey, message] = RefKeys
          const refValue = form[refKey]
          (this.rows || []).forEach((row) => {
            values.push(row[Key])
          })
          if(!/^\d+(\.\d{1,2})?$/.test(value)) {
            callback(new Error('请填写数字'))
          } else {
            if(refValue === '' || !/^\d+(\.\d{1,2})?$/.test(refValue)) {
              callback(new Error(message))
            } else if(values.indexOf('') >= 0) {
              callback()
            } else {
              let total = values.reduce((pre, cur, index) => {
                return (0 - -pre - -cur).toFixed(2)
              }, '0')
              if(0 + -total === 0 + -refValue) {
                callback()
              } else {
                callback(new Error(`子项目总分必须等于${refValue}`))
              }
            }
          }
        }
      })
    },
    isDateTime(type) {
      return ['date', 'datetime'].indexOf(type) >= 0
    },
    getRequiredCount() {
      return this.requiredColumns
    }
  },
  watch: {
    value() {
      this.rows = this.value
      this.$nextTick(() => {
        this.doValidate()
      })
    }
  }
}
</script>
<style lang="scss">
.cus-addable-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  thead, .cus-table-thead {
    background: #EEF1F6;
  }
  th, td {
    padding: 10px;
    vertical-align: top;
    border: 1px solid #DFE6EC
  }
  .text-left {
    text-align: left;
  }
  .cat-p {
    margin: 0;
    .el-form-item {
      display: inline;
      margin-right: 0;
    }
  }
  .el-form-item--default, .el-form-item {
    .el-form-item__content {
      display: inline;
    }
  }
}
</style>